// extracted by mini-css-extract-plugin
export default {"image":"background__image__Yl7nP","color":"background__color__UM4DC","video":"background__video__dSzvd","videoEnabled":"background__videoEnabled__nqhoP"};